module.exports = __webpack_public_path__ + "img/game_gchess.b2aa84b.webp";